namespace TabAurous.Purchase {
    export interface PurchaseMasterForm {
        TransDate: Serenity.DateEditor;
        Posted: LabelEditor;
        TransId: Serenity.StringEditor;
        VoucherNo: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        PartyId: Serenity.LookupEditor;
        LedgerName: Serenity.StringEditor;
        Address1: Serenity.TextAreaEditor;
        State: Serenity.StringEditor;
        Country: Serenity.StringEditor;
        GSTState: Serenity.StringEditor;
        UserId: Serenity.LookupEditor;
        EmployeeId: Serenity.IntegerEditor;
        TermsId: Serenity.IntegerEditor;
        BillNo: Serenity.StringEditor;
        BillDate: Serenity.DateEditor;
        ChallanNo: Serenity.StringEditor;
        ChallanDate: Serenity.DateEditor;
        CurrencyId: Serenity.LookupEditor;
        ExchRate: AmountEditor;
        GstVat: Serenity.StringEditor;
        TaxRegType: Serenity.StringEditor;
        ProductItemImage: Serenity.ImageUploadEditor;
        ItemDetails: PurchaseItemsEditor;
        TaxDetails: PurchaseTaxEditor;
        ShipmentId: Serenity.IntegerEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: WeightEditor;
        NetWeight: WeightEditor;
        NetAmount: AmountEditor;
        CCNetAmount: AmountEditor;
        TaxAmount: AmountEditor;
        CCTaxAmount: AmountEditor;
        Discount: AmountEditor;
        AdditionalCharges: AmountEditor;
        RoundOff: AmountEditor;
        CCRoundOff: AmountEditor;
        GrossAmount: AmountEditor;
        CCGrossAmount: AmountEditor;
        Remark: Serenity.TextAreaEditor;
        ShipAddressId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
        CompanyId: Serenity.IntegerEditor;
    }

    export class PurchaseMasterForm extends Serenity.PrefixedContext {
        static formKey = 'Purchase.PurchaseMaster';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PurchaseMasterForm.init)  {
                PurchaseMasterForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = LabelEditor;
                var w2 = s.StringEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.LookupEditor;
                var w5 = s.TextAreaEditor;
                var w6 = AmountEditor;
                var w7 = s.ImageUploadEditor;
                var w8 = PurchaseItemsEditor;
                var w9 = PurchaseTaxEditor;
                var w10 = WeightEditor;

                Q.initFormType(PurchaseMasterForm, [
                    'TransDate', w0,
                    'Posted', w1,
                    'TransId', w2,
                    'VoucherNo', w2,
                    'VoucherTypeId', w3,
                    'PartyId', w4,
                    'LedgerName', w2,
                    'Address1', w5,
                    'State', w2,
                    'Country', w2,
                    'GSTState', w2,
                    'UserId', w4,
                    'EmployeeId', w3,
                    'TermsId', w3,
                    'BillNo', w2,
                    'BillDate', w0,
                    'ChallanNo', w2,
                    'ChallanDate', w0,
                    'CurrencyId', w4,
                    'ExchRate', w6,
                    'GstVat', w2,
                    'TaxRegType', w2,
                    'ProductItemImage', w7,
                    'ItemDetails', w8,
                    'TaxDetails', w9,
                    'ShipmentId', w3,
                    'Pieces', w3,
                    'Weight', w10,
                    'NetWeight', w10,
                    'NetAmount', w6,
                    'CCNetAmount', w6,
                    'TaxAmount', w6,
                    'CCTaxAmount', w6,
                    'Discount', w6,
                    'AdditionalCharges', w6,
                    'RoundOff', w6,
                    'CCRoundOff', w6,
                    'GrossAmount', w6,
                    'CCGrossAmount', w6,
                    'Remark', w5,
                    'ShipAddressId', w3,
                    'FinancialYearId', w3,
                    'CompanyId', w3
                ]);
            }
        }
    }
}
